import { commonHttp as http } from '@web-publish-id/shared/http'
import { checkPaymentRetry } from '../utils/paymentRetry'
import {
  PaymentOrderInfoRes,
  PaymentExchangeRate,
  PublishChannelPaymentListReq,
  PublishChannelPaymentListRes,
  GetPaymentMethodListReq,
  PublishPaymentMethodListRes,
  CreatePaymentLinkOrderReq,
  CreatePaymentLinkOrderRes,
  CreatePaymentDropinOrderReq,
  CreatePaymentDropinOrderRes,
  CreatePaymentDropinOrderDetailReq,
  CreatePaymentDropinOrderDetailRes,
  PaymentInitConfigRes,
  GetPaymentUserBindInfoListReq,
  GetPaymentUserBindInfoListRes,
  GetPaymentChannelSessionReq,
  GetPaymentChannelSessionRes,
  GetPaymentStatusRes,
} from './types/payment'

/**
 * 获取支付配置
 * @param data
 * @returns
 */
export const getPaymentInitConfig = () => {
  return http.post<PaymentInitConfigRes>('/payment/init_config', {})
}

/**
 * 获取订单信息
 * @param data
 * @returns
 */
export const getPaymentOrderInfo = (data: { sys_order_id: string }) => {
  return http.post<PaymentOrderInfoRes>('/payment/order_info', data)
}

/**
 * 获取支付方式列表
 */
export const getPaymentMethodList = (data: GetPaymentMethodListReq) => {
  return http.post<PublishPaymentMethodListRes>('/payment/method_list', data)
}

/** 获取订单参考汇率，无有效数据时不展示。 */
export const getPaymentExchangeRate = async (data: { sys_order_id: string }, signal?: AbortSignal): Promise<PaymentExchangeRate | null> => {
  if (!data.sys_order_id?.trim()) return null
  const res = await http.post<{ exchange_data?: PaymentExchangeRate }>('/payment/get_exchange_rate_by_sys_order_id', data, { signal })
  const rate = res?.exchange_data
  if (!rate || typeof rate.exchange_rate !== 'number' || !Number.isFinite(rate.exchange_rate) || rate.exchange_rate <= 0
    || typeof rate.original_currency !== 'string' || !rate.original_currency.trim()
    || typeof rate.target_currency !== 'string' || !rate.target_currency.trim()) return null
  return rate
}

/**
 * 获取渠道方支付方式列表
 * @param data
 * @returns
 */
export const getPaymentChannelMethodList = (data: PublishChannelPaymentListReq = { payment_channel_type: 1 }) => {
  return http.post<PublishChannelPaymentListRes>('/payment/channel_method_list', data)
}

/**
 * 创建订单
 * @param data
 * @returns
 */
export const createPaymentLinkOrder = (data: CreatePaymentLinkOrderReq) => {
  return http.post<CreatePaymentLinkOrderRes>('/payment/link/create_order', data)
}

/**
 * 创建支付订单dropin
 * @param data
 * @returns
 */
export const createPaymentDropinOrder = (data: CreatePaymentDropinOrderReq) => {
  return http.post<CreatePaymentDropinOrderRes>('/payment/dropin/create_order', data).then(checkPaymentRetry)
}
/**
 * dropin 补充信息
 * @param data
 * @returns
 */
export const createPaymentDropinOrderDetail = (data: CreatePaymentDropinOrderDetailReq) => {
  return http.post<CreatePaymentDropinOrderDetailRes>('/payment/dropin/order_detail', data)
}

/**
 * 获取用户绑卡信息列表
 */
export const getPaymentUserBindInfoList = (data: GetPaymentUserBindInfoListReq) => {
  return http.post<GetPaymentUserBindInfoListRes>('/payment/get_user_bind_info_list', data)
}

/**
 * 删除用户绑卡信息
 */
export const cancelPaymentUserBindInfo = (data: { instrument_ids: string[] }) => {
  return http.post<any>('/payment/cancel_user_bind', data)
}

/**
 * 获取渠道session
 * @param data
 * @returns
 */
export const getPaymentChannelSession = (data: GetPaymentChannelSessionReq) => {
  return http.post<GetPaymentChannelSessionRes>('/payment/get_channel_session', data)
}

/**
 * 查询支付单状态（收银台 callback 轮询用）
 * @param data
 * @returns
 */
export const getPaymentStatus = (data: { payment_id: string }) => {
  return http.post<GetPaymentStatusRes>('/payment/payment_status', data)
}
